module.exports = __webpack_public_path__ + "static/img/desktop.3c5805d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/desktop.jpg
// module id = 6CCb
// module chunks = 12